import CardWrapper from "./CardWrapper";
import styles from "../../styles/portfolioManagerDashboard.module.scss";
import { HealthKpiStatus } from "../../../../helpers/utils";

const statusLabel = (status) => HealthKpiStatus.find((s) => s.value === status)?.name ?? "On Target";
const statusColor = (status) => HealthKpiStatus.find((s) => s.value === status)?.color ?? HealthKpiStatus[0].color;

function HealthBadgeCard({ current = 0, trending = 0, infoText }) {
  return (
    <CardWrapper classNames={styles.simpleCard} infoText={infoText}>
      <div className={styles.cardTop}>
        <span className={styles.label}>Health</span>
        <div className={styles.cardMain} style={{ justifyContent: "center" }}>
          <div className={styles.value} style={{ fontSize: 22, color: statusColor(current) }}>
            {statusLabel(current)}
          </div>
        </div>
      </div>
      <div className={styles.cardFooter} style={{ justifyContent: "center" }}>
        <span
          className={styles.trendBadge}
          style={{ color: statusColor(trending), background: `${statusColor(trending)}1A` }}
        >
          {`Trending: ${statusLabel(trending)}`}
        </span>
      </div>
    </CardWrapper>
  );
}

export default HealthBadgeCard;
